import React, { Component, useRef } from "react";
import { Link, } from 'react-router-dom'; // Link,

import ReactHlsPlayer from 'react-hls-player'

import ReactPlayer from 'react-player'

export default class Webtv extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
    }
  }

  componentDidMount = async () => {

  }

  render() {

    return (
      <div>
        {
          /**
           *  
           * <video id=example-video width=960 height=540 class="video-js vjs-default-skin" controls>
          <source
             src="https://example.com/index.m3u8"
             type="application/x-mpegURL">
        </video>
           */
        }

        {
          /**
           *         <ReactHlsPlayer
                  url='https://tjktv.ercdn.net/tjktvmobil.m3u8'
                  autoplay={true}
                  controls={true}
                  //  width={500}
                  height={375}
                />
           */
        }

        {
          /**
           *   <iframe
            width='100%'
            height={400}
            src="https://www.youtube.com/embed/SXExRtTfKZs"
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen />
           */
        }


        <div

          style={{
            backgroundColor: '#f02',
          }}>

          <div className="row no-gutters">
            <div className="col">
              <div className="row no-gutters" style={{ height: 40 }}>
                <div className="col-2" />

                <div className="col-2">
                  <Link to="/" className="btn btn-glossred  w-100 rounded-0">
                    Bahis Yap
</Link>
                </div>
                <div className="col-2">
                  <Link to="/webtv" className="btn btn-glossred  w-100 rounded-0">
                    Web Tv
</Link>
                </div>
                <div className="col-2">
                  <Link to="/program" className="btn btn-glossred  w-100 rounded-0">
                    Program
</Link>
                </div>


                <div className="col-2">
                  <Link to="/panel" className="btn btn-glossred  w-100 rounded-0">
                    Yönetim
    </Link>
                </div>

                <div className="col-2">
                  <Link to="/panel/result" className="btn btn-glossred  w-100 rounded-0">
                    Sonuçlar
                 </Link>
                </div>
              </div>
            </div>
          </div>

        </div>
        <ReactPlayer
          url='https://tjktv.ercdn.net/tjktvmobil.m3u8'
          controls={true}
          playing={true}
          width={'100%'}
        />


      </div>)
  }
}